/**
 * 타입 안전한 GA4 이벤트 전송 및 사용자 식별
 */
import { gtagEvent, gtagSet } from './gtag';
import type { AnalyticsUserProperties, EventName, ExtractEventParams } from './types';

/**
 * 타입 안전한 이벤트 전송
 * - 이벤트 이름과 params 간 타입 매핑 강제
 * - 모든 이벤트에 event_source: 'webview' 태그 자동 추가
 */
export function trackEvent<N extends EventName>(
  eventName: N,
  ...rest: ExtractEventParams<N> extends void ? [] : [params: ExtractEventParams<N>]
): void {
  const params = rest[0] as Record<string, unknown> | undefined;
  gtagEvent(eventName, {
    ...params,
    event_source: 'webview',
  });
}

/**
 * GA4 사용자 식별 설정
 * - null 전달 시 사용자 ID 초기화 (로그아웃)
 */
export function setAnalyticsUser(props: AnalyticsUserProperties | null): void {
  if (props === null) {
    gtagSet({ user_id: null });
    return;
  }

  const { user_id, ...userProperties } = props;

  // user_id 설정
  gtagSet({ user_id });

  // 사용자 속성 설정 (undefined 값 제거)
  const cleanProperties = Object.fromEntries(
    Object.entries(userProperties).filter(([, v]) => v !== undefined),
  );

  if (Object.keys(cleanProperties).length > 0) {
    gtagSet({ user_properties: cleanProperties });
  }
}

/**
 * 사용자 속성 부분 업데이트
 */
export function updateUserProperties(
  props: Partial<Omit<AnalyticsUserProperties, 'user_id'>>,
): void {
  const cleanProperties = Object.fromEntries(
    Object.entries(props).filter(([, v]) => v !== undefined),
  );

  if (Object.keys(cleanProperties).length > 0) {
    gtagSet({ user_properties: cleanProperties });
  }
}
